import styled from '@emotion/styled';
import { fontWeight } from 'src/assets/fonts-config';
import { Container } from 'src/components/Header/LHSMenu/MainMenu.style';
import { MenuItemsNavigation } from 'src/components/Menu/Menu.style';

/* stylelint-disable */
export const SideMenuContainer = styled(MenuItemsNavigation, { label: 'SideMenuContainer' })`
    background: hsl(var(--muted));
    flex: 0 0 200px;
    width: 200px;
    padding: 20px 12px 12px;
    max-height: 100vh;
`;
interface MenuButtonWrapperType {
    isActive: boolean;
    isDisabled?: boolean;
}

export const SideContainer = styled(Container, { label: 'SideContainer' })`
    max-height: 100%;
`;

export const MenuButtonWrapper = styled('button', { label: 'MenuButtonWrapper' }) <MenuButtonWrapperType>`
    /* background: ${({ isActive }): string => isActive ? 'rgba(104, 142, 158, 0.15)' : 'transparent'}; */
    /* border-radius: 6px; */
    background: transparent;
    border: none;
    color: ${({ isActive }): string => isActive ? 'hsl(var(--primary))' : 'hsl(var(--foreground))'};
    cursor: pointer;
    font-size: 14px;
    /* font-weight: ${({ isActive }): string => isActive ? fontWeight.medium : fontWeight.regular}; */
    opacity: ${({ isDisabled }): string => isDisabled === true ? '.2' : '1'};
    ${({ isDisabled }): string => isDisabled === true ? 'pointer-events: none' : ''};
    height: 32px;
    line-height: 1.143;
    padding: 8px 12px;
    text-align: left;
    transition: color .2s ease;
    width: 100%;
    &:hover {
       color: ${({ isActive }): string => isActive === true ? '' : 'hsl(var(--muted-foreground))'};
    }
`;
